export default "__VITE_ASSET__CmYbC83E__"